
import HomeButton from '@/components/HomeButton.vue'
import store from '@/store'
import { ref } from 'vue'

const pwaConfig = ref<any>({})

const showMap = (context: any) => {
  context.$emit('map');
}

const showPoint = (context: any, pointGuid: string) => {
  context.$emit('point', pointGuid);
}

const showSubmap = (context: any, submapGuid: string) => {
  context.$emit('submap', submapGuid);
}

const processButtonClick = (welcomeButtonPref: string, context: any) => {
  let command = welcomeButtonPref.split(':')[0] || 'map'
  const guid = welcomeButtonPref.split(':')[1] || ''

  const buttonCommands: { [key: string]: () => void } = {
    'map': () => showMap(context),
    'point': () => showPoint(context, guid),
    'submap': () => showSubmap(context, guid),
  }

  if (!buttonCommands[command]) {
    console.error('Unknown welcome button command: ' + command + ' (from "' + welcomeButtonPref + '")')
    command = 'map'
  }
  buttonCommands[command]()
}

export default {
  name: 'WelcomeLayout',
  components: {
    HomeButton,
  },
  computed: {
    backgroundColor(): string {
      const color = pwaConfig?.value?.color
      return color ? '#' + color : 'transparent'
    },
    backgroundPhoto(): string {
      return pwaConfig?.value?.background_photo || ''
    },
  },
  methods: {
    handleWelcomeButtonClick() {
      console.log('Welcome clicked:', pwaConfig.value.welcome_button_pref)
      processButtonClick(pwaConfig.value.welcome_button_pref || '', this)
    },
  },
  setup() {
    store.getPwaConfig().then(data => pwaConfig.value = data)
  }
}
